export class FileDownloadRequest {
    fileId: string;
    fileType: string;
    projectDocumentTypeId: string;
    userId: number;
    filePath: string;
    projectId: number;
    fileName: string;
}
